import React from 'react';
import { useRecoilState } from 'recoil';
import Chat from './Chat/Chat';
import './SidePanel.css';
import ParticipantsSection from './Participants/ParticipantsSection';
import { showChatWindowState } from '../../state/chatAtom';
import { showParticipantsWindowState } from '../../state/participantAtom';

export default function SidePanel() {
  const [showChat, setShowChat] = useRecoilState(showChatWindowState);
  const [showParticipants, setShowParticipants] = useRecoilState(showParticipantsWindowState);

  if (!showChat && !showParticipants) {
    return null;
  }

  return (
    <div className="side-section">
      {showChat && <Chat showChat={showChat} toggleChat={() => setShowChat((prev) => !prev)} />}
      {showParticipants && (
        <ParticipantsSection
          showParticipants={showParticipants}
          toggleParticipants={() => setShowParticipants((prev) => !prev)}
        />
      )}
    </div>
  );
}
